<template>
  <v-app>
<!--    <app-bar />-->
    <router-view />
  </v-app>
</template>

<script setup>

</script>